jQuery(function ($) {
    'use strict';

    if (typeof sevenarzAjax === 'undefined' || !sevenarzAjax.url) {
        return;
    }

    function appendPost($container, post) {
        var $column = $('<div>', { class: 'col-4 post' });
        var $link = $('<a>', { href: post.permalink || '#' });

        if (post.thumbnail) {
            $link.append($('<img>', {
                src: post.thumbnail,
                alt: '',
                loading: 'lazy',
                decoding: 'async'
            }));
        }

        $link.append($('<h3>', { class: 'title', text: post.title || '' }));
        $column
            .append($link)
            .append($('<p>', { class: 'date', text: post.date || '' }))
            .append($('<p>', { class: 'excerpt', text: post.excerpt || '' }))
            .append($('<p>', { class: 'categories' }).append('Categories: ', post.cat_list || ''))
            .append($('<p>', { class: 'tags' }).append('Tags: ', post.tag_list || ''));

        $container.append($column);
    }

    function loadMore(config, button) {
        var $button = $(button);
        var nextPage = Number($button.data('page') || 1) + 1;
        var requestData = {
            action: config.action,
            page: nextPage,
            nonce: sevenarzAjax.nonce
        };

        if (config.termKey) {
            requestData[config.termKey] = $button.data(config.termKey) || '';
        }

        $button.addClass('loading').attr('aria-disabled', 'true');
        $(config.loadingSelector).addClass('loading');

        $.ajax({
            url: sevenarzAjax.url,
            method: 'POST',
            dataType: 'json',
            data: requestData
        }).done(function (response) {
            var posts = response && Array.isArray(response.blog_data) ? response.blog_data : [];
            var total = response && response.max_posts && response.max_posts[0]
                ? Number(response.max_posts[0].no_of_posts)
                : 0;
            var $posts = $(config.postsSelector);

            posts.forEach(function (post) {
                appendPost($posts, post);
            });

            $button.data('page', nextPage);
            if (!posts.length || $posts.find('.post').length >= total) {
                $button.hide();
            }
        }).fail(function () {
            $button.attr('aria-label', 'Could not load more posts. Try again.');
        }).always(function () {
            $(config.loadingSelector).removeClass('loading');
            $button.removeClass('loading').removeAttr('aria-disabled');
        });
    }

    var listings = {
        archive_load_more: {
            action: 'archive_load_more',
            postsSelector: '#blog_archive .blog_posts',
            loadingSelector: '#blog_archive .blog_posts .loading_icon'
        },
        tag_load_more: {
            action: 'tag_load_more',
            termKey: 'tag',
            postsSelector: '#blog_tag_page .blog_posts',
            loadingSelector: '#blog_tag_page .blog_posts .loading_icon'
        },
        cat_load_more: {
            action: 'category_load_more',
            termKey: 'cat',
            postsSelector: '#blog_category_page .blog_posts',
            loadingSelector: '#blog_category_page .blog_posts .loading_icon'
        }
    };

    Object.keys(listings).forEach(function (id) {
        $(document).on('click', '#' + id + ':not(.loading)', function (event) {
            event.preventDefault();
            loadMore(listings[id], this);
        });
    });
});
